import React from 'react'
import styled from 'styled-components'
import { rhythm, color, media } from '../utils/typography'
import classnames from 'classnames'

import Container from './container'
import Link from './link'

export default styled(({ className, title, linkTo, linkText, children }) =>
  <section className={classnames('clearfix', className)}>
    {title ?
      <header>
        <Container>
          <h1>{title}</h1>
        </Container>
      </header>
    : null}
    <section>
      <Container>
        {children}
      </Container>
    </section>
    {linkTo && linkText ?
      <footer>
        <Container>
          <Link to={linkTo}>{linkText}&nbsp;&raquo;</Link>
        </Container>
      </footer>
    : null}
  </section>
)`
  header {
    border-bottom: 1px solid ${color.header};
    margin: ${rhythm(1)} 0 ${rhythm(2/3)};
    ${media.desktop} {
      margin-bottom: ${rhythm(3/4)};
    }
  }

  footer {
    margin-top: ${rhythm(1/4)};
    text-align: right;
  }
`
